export default function Announcements() {
  return (
    <section className="hsyc-section hsyc-venue" id="camp-venue">
      <div className="hsyc-wrap hsyc-venue__grid">
        <div>
          <h2>YMCA Camp Cullen</h2>
          <address>
            460 Cullen Loop
            <br />
            Trinity, Texas 75862
          </address>
          <p className="hsyc-venue__links">
            <a
              href="https://maps.app.goo.gl/SPjrrhDi9ajNhMHaA"
              target="_blank"
              rel="noreferrer"
            >
              Get directions
            </a>
            <a href="https://ymcacampcullen.org/" target="_blank" rel="noreferrer">
              Visit the camp's website
            </a>
          </p>
        </div>
        <iframe
          title="Map of YMCA Camp Cullen"
          src="https://www.google.com/maps?q=YMCA+Camp+Cullen,+460+Cullen+Loop,+Trinity,+TX+75862&z=12&output=embed"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
}
